// Oturum belgesini (X-Session-Token) ana API'ye giden TÜM isteklere ekler.
// fetchApi zaten ekliyor; ama birçok ekran ana API'yi doğrudan fetch ile çağırıyor.
// ENFORCE_SESSION=true iken belgesiz istek 401 alır — bu yama hepsini kapsar.
import { projectId } from '../../../utils/supabase/info';
import { forceRelogin, PLAN_FREE_ROLE_NOTICE_KEY } from './session-token';
import { planLimitDetail } from './plan-texts';
import { isFreeRoleBlock } from './plan-gates';

// Oturum belgesi yalnız kendi Supabase projemizdeki bu fonksiyonlara gider (başka adreslere sızmasın)
const API_BASE = `https://${projectId}.supabase.co/functions/v1/`;
const SESSION_FUNCTIONS = ['make-server-df8bdc4f', 'z-report-v3'];
const needsSession = (url: string) =>
  url.startsWith(API_BASE) && SESSION_FUNCTIONS.some(f => url.startsWith(API_BASE + f + '/') || url.startsWith(API_BASE + f + '?') || url === API_BASE + f);
// Giriş isteği: kullanıcı henüz içeride değil, "Satın al" penceresi açılmaz (LoginPage kendi uyarısını gösterir)
const isLoginUrl = (url: string) => /\/(login|google-login)(\?|$)/.test(url.split('#')[0]);
/** Oturumdaki kullanıcının rolü (localStorage 'user') */
const currentRole = (): string | null => {
  try { return JSON.parse(localStorage.getItem('user') || 'null')?.role ?? null; } catch { return null; }
};

export function installSessionFetch(): void {
  if (typeof window === 'undefined' || (window as any).__sessionFetchInstalled) return;
  (window as any).__sessionFetchInstalled = true;
  const original = window.fetch.bind(window);

  // Sunucu "oturum gerekli/geçersiz" derse (401) oturum kapatılıp yeniden giriş istenir.
  // Paket sınırı / abonelik kilidi (402) → 'plan-limit' olayı; PlanProvider "Satın al" penceresini açar.
  // Yanıt her zaman olduğu gibi döner (gövde klonlanarak okunur, çağıran kendi hatasını işler).
  const watch = (url: string, p: Promise<Response>): Promise<Response> => {
    if (!url.startsWith(API_BASE)) return p;
    return p.then((res) => {
      try {
        if (res.status === 401 && needsSession(url) && localStorage.getItem('user')) {
          res.clone().json().then((d: any) => {
            if (/Oturum/i.test(String(d?.error || ''))) forceRelogin();
          }).catch(() => { /* gövde JSON değil */ });
        } else if (res.status === 402 && localStorage.getItem('user') && !isLoginUrl(url)) {
          res.clone().json().then((d: unknown) => {
            const detail = planLimitDetail(d);
            if (!detail) return;
            // Ücretsiz pakette patron dışı açık oturum (R7): personel satın alamaz → uyarı + çıkış
            if (isFreeRoleBlock(detail, currentRole())) { forceRelogin(PLAN_FREE_ROLE_NOTICE_KEY); return; }
            window.dispatchEvent(new CustomEvent('plan-limit', { detail }));
          }).catch(() => { /* gövde JSON değil */ });
        }
      } catch { /* izleyici hatası yanıtı etkilemesin */ }
      return res;
    });
  };

  window.fetch = (input: RequestInfo | URL, init?: RequestInit) => {
    let url = '';
    try {
      url = typeof input === 'string' ? input : input instanceof URL ? input.href : input.url;
      const token = localStorage.getItem('sessionToken');
      if (token && needsSession(url)) {
        const headers = new Headers(init?.headers || (input instanceof Request ? input.headers : undefined));
        if (!headers.has('X-Session-Token')) {
          headers.set('X-Session-Token', token.replace(/[^\x20-\x7E]/g, ''));
          return watch(url, original(input, { ...init, headers }));
        }
      }
    } catch { /* yama hatası isteği engellemesin */ }
    return watch(url, original(input, init));
  };
}
